import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import AdminDashboard from './admin-dashboard';
import AffiliateManagerDashboard from './affiliate-manager-dashboard';
import ExpoEditorDashboard from './expo-editor-dashboard';
import BoothBuilderDashboard from './booth-builder-dashboard';
import ExhibitorDashboard from './exhibitor-dashboard';
import UnassignedDashboard from './unassigned-dashboard';


/** @class Dashboard
  * A component for the home screen of a Vexpo Admin Platform user.
  * It serves a role-specific dashboard to a logged-in active user.
  */
export default class Dashboard extends ReactFireComponent {
  /** @constructor
    * Constructs a new Dashboard instance
    */
  constructor(props) {
    super(props);
    this.state = {
      role: "unassigned"
    }
  }
  /** @method componentWillMount
    * Determines the current user's role based on
    * the active user list in firebase.
    */
  componentWillMount() {
    const uid = firebase.auth().currentUser.uid;
    //const email = firebase.auth().currentUser.email;
    this.bindAsObject(`/users/${uid}/role`, 'role');
  }
  /** @method componentWillUnmount
    * Disconnects from the firebase database
    */
  componentWillUnmount() {
    this.unbind('role');
  }
  /** @method render
    * Renders the role-specific dashboard
    */
  render() {
    const uid = firebase.auth().currentUser.uid;
    const email = firebase.auth().currentUser.email;
    switch(this.state.role) {
      case 'Admin':
        return <AdminDashboard uid={uid} email={email} />
      case 'Affiliate Manager':
        return <AffiliateManagerDashboard/>
      case 'Expo Editor':
        return <ExpoEditorDashboard uid={uid} email={email} />
      case 'Booth Builder':
        return <BoothBuilderDashboard uid={uid} email={email} />
      case 'Exhibitor':
        return <ExhibitorDashboard uid={uid} email={email} />
      default:
        return <UnassignedDashboard uid={uid} email={email} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/dashboard/dashboard.js